import React, { useState } from 'react';

export default function VenueList({ venues, selectedId, onSelect, onAdd }) {
  const [search, setSearch] = useState('');
  const [searchFocused, setSearchFocused] = useState(false);
  const [addHover, setAddHover] = useState(false);

  const filtered = venues.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div
      style={{
        width: '320px',
        minWidth: '320px',
        borderRight: '1px solid #3a3a3a',
        backgroundColor: '#1a1a1a',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '20px 16px 12px 16px',
          borderBottom: '1px solid #3a3a3a',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '12px',
          }}
        >
          <span
            style={{
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 700,
              fontSize: '18px',
              color: '#F5F5F5',
            }}
          >
            Venues
          </span>
          <button
            onClick={onAdd}
            onMouseEnter={() => setAddHover(true)}
            onMouseLeave={() => setAddHover(false)}
            style={{
              backgroundColor: addHover ? '#8B1C26' : '#BF2634',
              color: '#FFFFFF',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 500,
              fontSize: '13px',
              padding: '6px 14px',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.15s ease',
            }}
          >
            +
          </button>
        </div>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
          placeholder="Search venues..."
          style={{
            width: '100%',
            backgroundColor: '#121212',
            border: `1px solid ${searchFocused ? '#39FF14' : '#3a3a3a'}`,
            borderRadius: '4px',
            padding: '8px 12px',
            color: '#F5F5F5',
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: '14px',
            outline: 'none',
            boxSizing: 'border-box',
            transition: 'border-color 0.15s ease',
          }}
        />
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {filtered.length === 0 ? (
          <div
            style={{
              padding: '24px 16px',
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 400,
              fontSize: '14px',
              color: '#565656',
              textAlign: 'center',
            }}
          >
            {venues.length === 0 ? 'No venues yet.' : 'No results found.'}
          </div>
        ) : (
          filtered.map((v) => (
            <VenueRow
              key={v._id}
              venue={v}
              isSelected={v._id === selectedId}
              onClick={() => onSelect(v._id)}
            />
          ))
        )}
      </div>
    </div>
  );
}

function VenueRow({ venue, isSelected, onClick }) {
  const [hovered, setHovered] = useState(false);

  const sub = [venue.venue_type, [venue.city, venue.state].filter(Boolean).join(', ')]
    .filter(Boolean)
    .join(' · ');

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '12px 16px 12px 13px',
        borderLeft: `3px solid ${isSelected ? '#39FF14' : 'transparent'}`,
        backgroundColor: isSelected
          ? 'rgba(57, 255, 20, 0.06)'
          : hovered
          ? 'rgba(255, 255, 255, 0.03)'
          : 'transparent',
        cursor: 'pointer',
        borderBottom: '1px solid #2a2a2a',
        transition: 'all 0.15s ease',
      }}
    >
      <div
        style={{
          fontFamily: "'Roboto', sans-serif",
          fontWeight: 500,
          fontSize: '14px',
          color: isSelected ? '#39FF14' : '#F5F5F5',
          marginBottom: sub ? '2px' : '0',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {venue.name}
      </div>
      {sub && (
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: '12px',
            color: '#888888',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {sub}
        </div>
      )}
    </div>
  );
}
